import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { ImageNodeAttrs } from './Types'
import { SelectedImage } from 'types'
import { Fragment } from 'prosemirror-model'

export const buildImageDragClone = (imgOrDiv: HTMLDivElement | HTMLImageElement) => {
  if (imgOrDiv instanceof HTMLDivElement) {
    // Return a clone of the div that is displayed when the image is unavailable.
    const clone = imgOrDiv.cloneNode() as HTMLDivElement
    clone.id = 'dragClone'
    return clone
  }
  // Return a clone of the actual <img/>.
  const clone = imgOrDiv.cloneNode() as HTMLImageElement
  clone.id = 'dragClone'
  const reactRzContainer = imgOrDiv.closest<HTMLDivElement>('.react-resizable')
  if (reactRzContainer) {
    clone.style.width = reactRzContainer.style.width
    clone.style.height = reactRzContainer.style.height
  }
  return clone
}

export const replaceImageWithImages = (
  view: EditorView<typeof schema>,
  attrs: ImageNodeAttrs,
  images: SelectedImage[],
) => {
  const newSlice = Fragment.fromArray(
    images.map((image) => {
      let attrs: Partial<ImageNodeAttrs> = {
        src: image.url,
      }

      if (image.unsplash) {
        attrs.source = 'unsplash'
        attrs.unsplashQuery = image.unsplash.query
        attrs.unsplashId = image.unsplash.id
      }

      return view.state.schema.nodes.image.create(attrs)
    }),
  )

  const tr = view.state.tr
  view.state.doc.descendants((node, pos) => {
    if (node.attrs.src === attrs.src) {
      tr.replaceWith(pos, pos + node.nodeSize, newSlice)
    }
  })
  view.dispatch(tr)
}
